module.exports = {

    'title_landing_pages': 'Promotions',
    'description_landing_pages': 'AYANA Rewards offers irresistible stay & play packages to <br/> suit your travel lifestyle.',
    'crumb_home': 'Home',
    'crumb_promotion': 'Promotion',
}